export const ChevronRightIcon = ({
  width = 6,
  height = 11,
  viewBox = '0 0 6 11',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className="shrink-0"
    >
      <path
        d="M0.75 9.75L5.25 5.25L0.75 0.75"
        stroke="#75777D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
